import { atom } from 'jotai';

import type { ImageQualityResult } from '@/@types/latestImagesV2';

import annotatorConstants from './annotator.constants';

export const fmxVersionAtom = atom<1 | 2 | undefined>(undefined);

export const latestImagesVisitDateAtom = atom<Date | undefined>(undefined);

export const showPastVisitsAtom = atom(false);

export const viewerModeAtom = atom(annotatorConstants.MODES.VIEWING);

export const imageFilterAtom = atom<string | undefined>(undefined);

export const sidebarIsNotCollapsedAtom = atom(true);

export const shouldDisplayRootTipsAtom = atom(true);

export const imageQualityAtom = atom<ImageQualityResult[] | undefined>(
  undefined,
);

export enum FmxSortKey {
  CURRENT_ORDER = 'CURRENT_ORDER',
  IMAGING_SOFTWARE_ORDER = 'IMAGING_SOFTWARE_ORDER',
  VIDEA_TEMPLATE_ORDER = 'VIDEA_TEMPLATE_ORDER',
}
// Typing as a string because the atom might contain an unknown but legitimate
// string value from the backend
export const selectedFmxSortKeyAtom = atom<string | undefined>(
  FmxSortKey.CURRENT_ORDER,
);

export const perioChartThemeAtom = atom<'dark' | 'light'>('dark');
